import Vue from 'vue';


import Component from 'vue-class-component';


import Tab from './Tab'; 


@Component({
props:{

}
})
export default class Tabs extends Vue{
  tabs=[];




mounted(){
  //console.log("Children  ", this.$children);
  

}


created(){
  this.tabs = this.$children;
  //console.log('hier the tabs s: ',this.tabs);
}

selectTab(selectedTab:Tab):void{
  this.tabs.forEach(tab=>{
    tab.isActive = tab.name===selectedTab.name;
  //  console.log("SelectedTab:"+selectedTab.name+" | tab:"+tab.name+"  | actve:"+tab.isActive+" | selected:"+tab.selected) 
  });
}



}
